<template>
  <div>
    <az-back-button :route="{name: 'comissoesBusca'}" text="Voltar para listagem"></az-back-button>
    <az-container>
      <comissao-acoes/>
      <comissao-dados v-model="comissaoLocal" :orgaos-list="orgaosList" :editando="editando"/>
      <div class="az-actions-form" v-az-auth="'Comissao.Atualizar'">
        <div class="align-left"></div>
        <div class="align-right">
          <button class="action-primary" @click.prevent="salvar">Salvar</button>
        </div>
      </div>
    </az-container>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import ComissaoAcoes from './ComissaoAcoes'
import ComissaoDados from './ComissaoDados'

export default {
  name: 'ComissaoAtualizacao',
  components: {ComissaoAcoes, ComissaoDados},
  data() {
    return {
      editando: false,
      comissaoLocal: {
        comissaoApuracao: {
          orgao: { id: null, nome: null, logradouro: null }
        },
        comissaoConfiguracao: {},
        comissaoUsuarios: [],
      },
      orgaosList: [],
      comissaoId: undefined
    }
  },
  computed: {
    ...mapState(['comissao'])
  },
  watch: {
    comissao: {
      handler() {
        this.setComissaoLocal()
      }
    }
  },
  async mounted() {
    this.setEditando(this.$route.query.edicao)
    this.setComissaoId(this.$route.params.id)
    await this.buscarOrgaos()
    await this.buscarComissao()
    this.setComissaoLocal()
  },
  methods: {
    ...mapActions([actionTypes.BUSCAR_COMISSAO_APURACAO, actionTypes.ATUALIZAR_COMISSAO]),
    async buscarComissao() {
      this.setMensagemLoading('Carregando Comissão...')
      await this.buscarComissaoApuracao(this.comissaoId)
    },
    setComissaoId(comissaoId) {
      this.comissaoId = comissaoId
    },
    setComissaoLocal() {
      this.comissaoLocal = _.cloneDeep(this.comissao)
      this.normalizarDatas(this.comissaoLocal)
    },
    normalizarDatas(comissao) {
      const configuracaoComissao = _.get(comissao, 'comissaoApuracao')
          ? comissao.comissaoConfiguracao
          : _.get(comissao, 'comissaoConfiguracao')

      if (!configuracaoComissao) return

      const camposDeData = [
        'dtInicioVigencia',
        'dtFimVigencia',
        'dataResolucao',
        'dtPublicacao'
      ]

      camposDeData.forEach(nomeCampo => {
        const valorCampo = _.get(configuracaoComissao, nomeCampo)
        if (!valorCampo) return

        let dataFormatada = null

        // Caso seja string no formato ISO → extrai apenas a parte da data (YYYY-MM-DD)
        if (typeof valorCampo === 'string') {
          const formatoIso = valorCampo.match(/^(\d{4}-\d{2}-\d{2})/)
          if (formatoIso) {
            dataFormatada = formatoIso[1]
          } else {
            // Caso esteja no formato BR (dd/MM/yyyy) → converte para (yyyy-MM-dd)
            const formatoBr = valorCampo.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
            if (formatoBr) {
              dataFormatada = `${formatoBr[3]}-${formatoBr[2]}-${formatoBr[1]}`
            }
          }
        }

        // Caso seja Date ou timestamp → converte para (yyyy-MM-dd)
        if (!dataFormatada && valorCampo instanceof Date) {
          dataFormatada = valorCampo.toISOString().slice(0, 10)
        }

        if (!dataFormatada && typeof valorCampo === 'number') {
          dataFormatada = new Date(valorCampo).toISOString().slice(0, 10)
        }

        if (dataFormatada) {
          _.set(configuracaoComissao, nomeCampo, dataFormatada)
        }
      })
    },
    setEditando(editando) {
      this.editando = typeof editando !== 'undefined' && (editando.toString() === 'true')
    },
    async buscarOrgaos(){
      const response = await this.$store.dispatch(actionTypes.BUSCAR_ORGAOS)
      if(response){
        this.orgaosList = response
      }
    },
    async salvar() {
      const validado = await this.$validator._base.validateAll()
      if (!validado) return

      if (!this.comissaoLocal.comissaoApuracao.orgao.id) {
        this.mostrarNotificacaoErro('Informe o órgão da comissão!')
        return
      }

      this.setMensagemLoading('Salvando comissão...')

      await this.atualizarComissao(this.comissaoLocal)

      this.mostrarNotificacaoSucesso('Comissão salva com sucesso!')
    }
  }
}
</script>
